.TagSingleMulti635500568__root {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 6px;
}

.TagSingleMulti635500568__input {
    opacity: 0;
    position: fixed;
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
}

.TagSingleMulti635500568__label {
    -st-states: 
        selected;

    border: 1px solid #a8caff;
    border-radius: 4px;
    padding: 2px 12px;
    background: #fff;
}

/* Hover */
.TagSingleMulti635500568__label:hover {
    cursor: pointer;
    border-color: #5999ff;
}

/* Selected */
.TagSingleMulti635500568__label.TagSingleMulti635500568--selected {
    border-color: #116dff;
}

/* Focus */
.TagSingleMulti635500568__input:focus-visible + label {
    outline: 2px solid #80b1ff;
    border-color: #5999ff;
}
/* st-namespace-reference="../../../../src/atoms/SelectionTags/TagSingleMulti.st.css" */